"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  getApiMinerClient: true,
  ApiMiner: true,
  ApiMinerAccount: true,
  ApiMinerEvent: true,
  ApiMinerTransaction: true,
  ApiMinerBlock: true,
  ApiMinerRawEvent: true,
  ApiMinerTokenInfo: true,
  ApiMinerTokenTransfer: true
};
Object.defineProperty(exports, "ApiMiner", {
  enumerable: true,
  get: function () {
    return _ApiMiner.default;
  }
});
Object.defineProperty(exports, "ApiMinerAccount", {
  enumerable: true,
  get: function () {
    return _Accounts.ApiMinerAccount;
  }
});
Object.defineProperty(exports, "ApiMinerBlock", {
  enumerable: true,
  get: function () {
    return _Network.ApiMinerBlock;
  }
});
Object.defineProperty(exports, "ApiMinerEvent", {
  enumerable: true,
  get: function () {
    return _Transactions.ApiMinerEvent;
  }
});
Object.defineProperty(exports, "ApiMinerRawEvent", {
  enumerable: true,
  get: function () {
    return _Contracts.ApiMinerRawEvent;
  }
});
Object.defineProperty(exports, "ApiMinerTokenInfo", {
  enumerable: true,
  get: function () {
    return _Tokens.ApiMinerTokenInfo;
  }
});
Object.defineProperty(exports, "ApiMinerTokenTransfer", {
  enumerable: true,
  get: function () {
    return _Tokens.ApiMinerTokenTransfer;
  }
});
Object.defineProperty(exports, "ApiMinerTransaction", {
  enumerable: true,
  get: function () {
    return _Transactions.ApiMinerTransaction;
  }
});
exports.getApiMinerClient = getApiMinerClient;
var _axios = _interopRequireDefault(require("axios"));
var _ApiMiner = _interopRequireDefault(require("./client/ApiMiner"));
var _Accounts = require("./client/Accounts");
Object.keys(_Accounts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Accounts[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Accounts[key];
    }
  });
});
var _Transactions = require("./client/Transactions");
Object.keys(_Transactions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Transactions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Transactions[key];
    }
  });
});
var _Network = require("./client/Network");
Object.keys(_Network).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Network[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Network[key];
    }
  });
});
var _Contracts = require("./client/Contracts");
Object.keys(_Contracts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Contracts[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Contracts[key];
    }
  });
});
var _Tokens = require("./client/Tokens");
Object.keys(_Tokens).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Tokens[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Tokens[key];
    }
  });
});
var _axiosRateLimit = _interopRequireDefault(require("@hokify/axios-rate-limit"));
var _CachedContractsApi = require("./CachedContractsApi");
Object.keys(_CachedContractsApi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _CachedContractsApi[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CachedContractsApi[key];
    }
  });
});
var _Users = require("./client/Users");
Object.keys(_Users).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Users[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Users[key];
    }
  });
});
var _TypeMap = require("./TypeMap");
Object.keys(_TypeMap).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TypeMap[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TypeMap[key];
    }
  });
});
var _apiminer = require("@blockwell/apiminer");
Object.keys(_apiminer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _apiminer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _apiminer[key];
    }
  });
});
/**
 * @returns {ApiMiner}
 */
function getApiMinerClient(baseUrl, accessToken, requestsPerSecond = 0) {
  let client = _axios.default.create({
    maxContentLength: 1000000,
    paramsSerializer: {
      indexes: null
    },
    baseURL: baseUrl
  });
  if (requestsPerSecond) {
    client = (0, _axiosRateLimit.default)(client, {
      maxRPS: requestsPerSecond
    });
  }
  return new _ApiMiner.default(client, accessToken);
}
//# sourceMappingURL=index.js.map